// manually edited

export interface ExtraConfig {
  [key: string]: {
    numFrames: number;
  };
}

export const extraConfig: ExtraConfig = {
  // chaloupka: {
  //   numFrames: 2,
  // },
  // jeskyne_foreground: {
  //   numFrames: 1,
  // },
  // jeskyne_door: {
  //   numFrames: 1,
  // },
};
